import * as globals from "../globals";
import * as apiService from "../utils/apiService";
import * as filterUtils from "../utils/filters";
import { actionCreators as selectionsCreator} from "../store/Selections";
import {
	STUDY_RESET,
	STUDY_RECEIVE,
	FILTER_DESELECT,
	FILTER_DESELECT_ALL,
	FILTER_GROUPS_RECEIVE,
	FILTER_GROUP_COLLAPSE,
	FILTER_GROUP_COLLAPSE_ALL,
	FILTER_GROUP_DESELECT,
	FILTER_GROUP_EXPAND,
	FILTER_GROUP_EXPAND_ONLY_SEARCHED_TERM,
	FILTER_SAMPLE_SIZES_RECEIVE,
	FILTER_SAMPLE_SIZES_REQUEST,
	FILTER_SELECT,
	FILTER_SET,
	FILTER_SET_CUSTOM_LABEL,
	FILTER_SET_USE_CUSTOM_LABEL,
	FILTER_SET_DEFAULTS
	// @ts-ignore
} from "./action-types";

export interface FilterState {
	filterGroups: any[];
	isLoading: boolean;
	selectedFilter: any;
	selected: any; // this is like selectedFilter except that it has an entry for each datasetId
	defaultFilterLabel: string;
	filterAlwaysIn: string; //syntax from this filter (eg 'seg01') will always be combined with the selected filters
}

const initialState: FilterState = {
	filterGroups: [],
	isLoading: false,
	selectedFilter: {
		autoLabel: "Total Population",
		syntax: "1==1",
		label: "Total Population",
		name: "total"
	},
	selected: null,
	defaultFilterLabel: "Total Population",
	filterAlwaysIn: ''
}

export const actionCreators = {
	// requestFilters: studyId => async (dispatch) => {
	//     dispatch({ type: `${filtersActionType}:REQUEST_FILTERS` });
	//     try {
	//         const url = `${globals.apiRoot}/study/${studyId}/filters`;
	//         const response = await fetch(url);
	//         const filters = await response.json();
	//         dispatch({ type: `${filtersActionType}:RECEIVED_FILTERS`, filters});
	//     } catch (err) {
	//         console.error(err);
	//     }
	// },

	expandFilterGroup: (id: any) => (dispatch: any, getState: any) =>
		dispatch({ type: FILTER_GROUP_EXPAND, id }),

	collapseFilterGroup: (id: any) => (dispatch: any, getState: any) =>
		dispatch({ type: FILTER_GROUP_COLLAPSE, id }),

	expandOnlySearchedFilterGroups: (term: any) => (
		dispatch: any,
		getState: any,
	) => dispatch({ type: FILTER_GROUP_EXPAND_ONLY_SEARCHED_TERM, term }),

	collapseAllFilterGroups: () => (dispatch: any, getState: any) =>
		dispatch({ type: FILTER_GROUP_COLLAPSE_ALL }),

	refreshSampleSizes: (datasetId?: string) => async (dispatch: any, getState: any) => {

		const state = getState()
		const study = state.study
		const filter = state.filter
		const selectedFilter = datasetId ? filter.selected[datasetId] : filter.selectedFilter
		const filterSyntax = selectedFilter ? selectedFilter.syntax : null

		// If there's no valid filter syntax, avoid making an unnecessary API request
		if (!filterSyntax) return

		const query = {
			measures: [{ syntax: "validcount(respid)", id: "n" }],
			filters: [{ syntax: filterSyntax }],
		}

		// console.log('refreshSampleSizes query', query)

		try {
			const response = await apiService.aPost(
				state.auth,
				`${globals.apiRoot}/study/${study.uid}/compute/yak`,
				query,
			)

			if (response.ok) {
				const value = await response.json()

				if (value && value.success) {
					dispatch({
						type: FILTER_SAMPLE_SIZES_RECEIVE,
						syntax: filterSyntax,
						datasetId, // ✅ Ensure datasetId is included in the dispatch
						n: value.results.n ? value.results.n.value : null,
					})
		console.log('FILTER.TS refreshSampleSizes', value?.results.n);

				}
			}
		} catch (error) {
			console.error(error);
			dispatch({
				type: FILTER_SAMPLE_SIZES_RECEIVE,
				syntax: filterSyntax,
				datasetId, // ✅ Ensure datasetId is included even on error
				n: null,
				error,
			})
		}
	},

	// selectFilter: (groupId: any, filterId: any, filterName?: any, datasetId?: any) => (dispatch: any, getState: any,) => {
	// 	dispatch({ type: FILTER_SELECT, groupId, filterId, filterName, datasetId });
	// 	actionCreators.refreshSampleSizes()(dispatch, getState);
	// },

	// deselectFilter: (groupId: any, filterId: any, datasetId?: any) => (dispatch: any,getState: any,) => {
	// 	dispatch({ type: FILTER_DESELECT, groupId, filterId, datasetId });
	// 	actionCreators.refreshSampleSizes()(dispatch, getState);
	// },
	
	selectFilter: (groupId: any, filterId: any, filterName: any, datasetId: any) => async (dispatch: any, getState: any) => {
		const state = getState()
		const { study, filter } = state

		// Step 1: Update `isSelected` in filterGroups without deselecting other filters
		const updatedFilterGroups = filter.filterGroups.map((fg) =>
			fg.id === groupId
				? {
					...fg,
					filters: fg.filters.map((f) => ({
						...f,
						isSelected: (f.isSelected || (f.id || f.syntax) === filterId), // Keep previous selections and add new one
					})),
				}
				: fg
		)

		// Step 2: Compute the selected filter using filterUtils
		let selectedFilterData = filterUtils.getSelectedFilter({ ...filter, filterGroups: updatedFilterGroups }, datasetId)

		// Step 3: Ensure `filterAlwaysIn` is included in the syntax
		if (filter.filterAlwaysIn) {
			const alwaysFilter = filter.filterGroups
				.flatMap((fg) => fg.filters)
				.find((f) => f.name?.toLowerCase() === filter.filterAlwaysIn?.toLowerCase())

			if (alwaysFilter?.syntax && !selectedFilterData.syntax.includes(alwaysFilter.syntax)) {
				selectedFilterData.syntax = `(${alwaysFilter.syntax} and ${selectedFilterData.syntax})`
			}
		}

		console.log('selectedFilterData.syntax ', selectedFilterData.syntax );
		// Step 4: Prepare the query for fetching sample size
		const query = {
			measures: [{ syntax: "validcount(respid)", id: "n" }],
			filters: [{ syntax: selectedFilterData.syntax }],
		}

		let samplesize = null
		try {
			const response = await apiService.aPost(
				state.auth,
				`${globals.apiRoot}/study/${study.uid}/compute/yak`,
				query
			)

			if (response.ok) {
				const value = await response.json()
				samplesize = value.results.n ? value.results.n.value : null
			}
		} catch (error) {
			console.error(error)
		}

		// Step 5: Attach the sample size to the selected filter
		if (samplesize) {
			selectedFilterData = {
				...selectedFilterData,
				n: samplesize,
			}
		}

		// Step 6: Dispatch the updated state to the reducer
		dispatch({
			type: FILTER_SELECT,
			groupId,
			filterId,
			datasetId,
			filterGroups: updatedFilterGroups,
			selectedFilter: selectedFilterData,
		})
	},

	deselectFilter: (groupId: any, filterId: any, datasetId: any) => async (dispatch: any, getState: any) => {
		const state = getState()
		const { study, filter } = state

		// Step 1: Update `isSelected` in filterGroups by deselecting the target filter
		const updatedFilterGroups = filter.filterGroups.map((fg) =>
			fg.id === groupId
				? {
					...fg,
					filters: fg.filters.map((f) => ({
						...f,
						isSelected: f.id !== filterId && f.syntax !== filterId && f.isSelected, // Deselect target filter, retain others
					})),
				}
				: fg
		)

		// Step 2: Compute the updated selected filter using filterUtils
		let updatedSelectedFilter = filterUtils.getSelectedFilter({ ...filter, filterGroups: updatedFilterGroups }, datasetId)

		// Step 3: Ensure `filterAlwaysIn` is included in the syntax if applicable
		if (filter.filterAlwaysIn) {
			const alwaysFilter = filter.filterGroups
				.flatMap((fg) => fg.filters)
				.find((f) => f.name?.toLowerCase() === filter.filterAlwaysIn?.toLowerCase())

			if (alwaysFilter?.syntax && !updatedSelectedFilter.syntax.includes(alwaysFilter.syntax)) {
				updatedSelectedFilter.syntax = `(${alwaysFilter.syntax} and ${updatedSelectedFilter.syntax})`
			}
		}

		// Step 4: Prepare the query for fetching the updated sample size
		const query = {
			measures: [{ syntax: "validcount(respid)", id: "n" }],
			filters: [{ syntax: updatedSelectedFilter.syntax }],
		}

		let samplesize = null
		try {
			const response = await apiService.aPost(
				state.auth,
				`${globals.apiRoot}/study/${study.uid}/compute/yak`,
				query
			)

			if (response.ok) {
				const value = await response.json()
				samplesize = value.results.n ? value.results.n.value : null
			}
		} catch (error) {
			console.error(error)
		}

		// Step 5: Attach the updated sample size to the selected filter
		if (samplesize) {
			updatedSelectedFilter = {
				...updatedSelectedFilter,
				n: samplesize,
			}
		}

		// Step 6: Dispatch the updated state to the reducer
		dispatch({
			type: FILTER_DESELECT,
			groupId,
			filterId,
			datasetId,
			filterGroups: updatedFilterGroups,
			selectedFilter: updatedSelectedFilter,
		})
	},



	// deselectFilter: (groupId: any, filterId: any, datasetId: any) => (dispatch: any, getState: any) => {
	// 	const state = getState().filter

	// 	// Update state: Mark filter as `isSelected: false`
	// 	let updatedState = {
	// 		...state,
	// 		filterGroups: state.filterGroups.map((fg) =>
	// 			fg.id === groupId
	// 				? {
	// 					...fg,
	// 					filters: fg.filters.map((f) =>
	// 						(f.id || f.syntax) === filterId ? { ...f, isSelected: false } : f
	// 					),
	// 				}
	// 				: fg
	// 		),
	// 	}

	// 	// Get the updated selected filter with correct syntax
	// 	const newSelectedFilter = datasetId
	// 		? {
	// 			...state.selected,
	// 			[datasetId]: filterUtils.getSelectedFilter(updatedState, datasetId),
	// 		}
	// 		: filterUtils.getSelectedFilter(updatedState)

	// 	dispatch({
	// 		type: FILTER_DESELECT,
	// 		groupId,
	// 		filterId,
	// 		datasetId,
	// 		selectedFilter: newSelectedFilter, // Ensures correct syntax & labels after deselection
	// 	})

	// 	actionCreators.refreshSampleSizes(datasetId)(dispatch, getState)
	// },



	deselectFilterGroup: (groupId: any, datasetId?: any) => (dispatch: any, getState: any) => {
		dispatch({ type: FILTER_DESELECT, groupId, datasetId });
		actionCreators.refreshSampleSizes(datasetId)(dispatch, getState);
	},

	deselectAll: (datasetId?: any) => (dispatch: any, getState: any) => {
		dispatch({ type: FILTER_DESELECT_ALL, datasetId });
		actionCreators.refreshSampleSizes(datasetId)(dispatch, getState);
	},

	setUseCustomLabel: (useCustomLabel: any) => (dispatch: any) => {
		dispatch({ type: FILTER_SET_USE_CUSTOM_LABEL, useCustomLabel });
	},

	setCustomLabel: (customLabel: any) => (dispatch: any) => {
		dispatch({ type: FILTER_SET_CUSTOM_LABEL, customLabel });
	},

	setFilterDefaults: (newDefaults:any, datasetId:any) => async (dispatch:any, getState:any) => {
		const state = getState().filter

		// Step 1: **CLEAR ALL FILTERS (except filterAlwaysIn)**
		dispatch({ type: FILTER_DESELECT_ALL, datasetId })

		const payload = {
			filterAlwaysIn: newDefaults.filterAlwaysIn || null,
			defaultFilterLabel: newDefaults.defaultFilterLabel ?? state.defaultFilterLabel,
			selectedFilter: {
				...state.selectedFilter,
				...newDefaults.selectedFilter // ✅ Only use the new selectedFilter
			},
			selected: {
				[datasetId]: { // ✅ Ensure selected is fully replaced
					...state.selected[datasetId],
					...newDefaults.selected
				}
			}
		}

		// console.log('payload!!!!', payload)
    
		// Step 2: **Reset `selectedFilter` completely**
		dispatch({
			type: FILTER_SET_DEFAULTS,
			payload
		})

		// Step 3: **Ensure filterAlwaysIn is correctly handled**
		await new Promise(resolve => setTimeout(resolve, 0))
		dispatch(actionCreators.refreshSampleSizes(datasetId)) //(dispatch, getState)
	}



}

export const reducer = (state: FilterState = initialState, action: any): FilterState => {
	// state = state || initialState;
	
	switch (action.type) {
		
		case STUDY_RESET:
			return initialState;

		case STUDY_RECEIVE:
			let s = {
				...state,
				defaultFilterLabel:	action.value?.defaultFilterLabel || state.defaultFilterLabel,
			}
			s.selectedFilter = filterUtils.getSelectedFilter(s)
			return s

		case FILTER_GROUPS_RECEIVE:

			// create a default for each datasetId (if any)
			const selected = action.filterGroups.reduce((acc: any, fg: any) => {
				if (fg.datasetId && !acc[fg.datasetId]) {
					acc[fg.datasetId] = filterUtils.getSelectedFilter(state, fg.datasetId)
				}
				return acc;
			}, {})
			
			return {
				...state,
				filterGroups: action.filterGroups,
				isLoading: false,
				selected
			};

		case FILTER_GROUP_EXPAND_ONLY_SEARCHED_TERM:
			return {
				...state,
				filterGroups: state.filterGroups.map((fg) => {
					if (fg.label.toLowerCase().includes(action.term.toLowerCase()))
						return {
							...fg,
							isExpanded: true,
							matchedGroup: true,
							filters: fg.filters.map((f: any) => ({ ...f, matched: true })),
						};
					return {
						...fg,
						isExpanded:
							fg.filters.filter((f: any) =>
								f.label.toLowerCase().includes(action.term.toLowerCase()),
							).length > 0,
						matchedGroup:
							fg.filters.filter((f: any) =>
								f.label.toLowerCase().includes(action.term.toLowerCase()),
							).length > 0,
						filters: fg.filters.map((f: any) =>
							f.label.toLowerCase().includes(action.term.toLowerCase())
								? { ...f, matched: true }
								: { ...f, matched: false },
						),
					};
				}),
			};

		case FILTER_GROUP_COLLAPSE_ALL:
			return {
				...state,
				filterGroups: state.filterGroups.map((fg) => ({
					...fg,
					isExpanded: false,
					filters: fg.filters.map((f: any) => ({ ...f, matched: false })),
				})),
			};

		case FILTER_GROUP_EXPAND:
			return {
				...state,
				filterGroups: state.filterGroups.map((fg) => ({
					...fg,
					isExpanded: fg.id === action.id ? true : fg.isExpanded,
					isSearchingItem: fg.id === action.id ? true : false,
				})),
			};

		case FILTER_GROUP_COLLAPSE:
			return {
				...state,
				filterGroups: state.filterGroups.map((fg) => ({
					...fg,
					isExpanded: fg.id === action.id ? false : fg.isExpanded,
					isSearchingItem: fg.id === action.id ? true : false,
				})),
			}
		
		case FILTER_SET_DEFAULTS: {
			const { payload } = action

			return {
				...state,
				filterAlwaysIn: payload?.filterAlwaysIn,
				defaultFilterLabel: payload.defaultFilterLabel || state.defaultFilterLabel,
				selectedFilter: { // ✅ Fully replace selectedFilter
					...payload.selectedFilter
				},
				selected: { // ✅ Fully replace selected selections
					...payload.selected
				}
			}
		}


		
		case FILTER_SET: {

			const { selectedFilter, selections } = action

			let s = {
				...state,
				selectedFilter: selectedFilter,
				filterGroups: state.filterGroups.map((fg) => {
					if (selections) {
						let findFolder = selections?.find((sel: any) => sel.folderId === fg.id);
						// note: even if findGroup==null, we still want to make sure all filters are cleared
						let filters = fg.filters.map((f: any) => {
							let findFilter = findFolder?.selectedFilterIds?.find((fid: any) => fid === (f.id || f.syntax));
							if (findFilter) {
								return {
									...f,
									isSelected: true
								};
							}
							else {
								let r = {
									...f,
									isSelected: undefined
								};
								delete r.isSelected;
								return r;
							}
						})
						return { ...fg, filters };
					}
					else
						return fg;
				})
			}
			s.selectedFilter = filterUtils.getSelectedFilter(s);
			return s;
		}
			
		case FILTER_SELECT: {
			const { groupId, filterId, filterGroups, selectedFilter, datasetId } = action

			let updatedState = {
				...state,
				filterGroups, // ✅ Updates `filterGroups` safely
			}

			if (datasetId) {
				updatedState.selected = {
					...state.selected,
					[datasetId]: selectedFilter
				}
			}
			else {
				updatedState.selectedFilter = selectedFilter // ✅ Explicitly updates `selectedFilter`
			}

			return updatedState
		}



		case FILTER_DESELECT: {
			const { groupId, filterId, datasetId, filterGroups, selectedFilter } = action

			// Update `isSelected` in `filterGroups` with the provided `filterGroups`
			let updatedState = {
				...state,
				filterGroups
			}

			// Use `filterUtils.getSelectedFilter` to recompute the selected filters
			if (datasetId) {
				updatedState.selected = {
					...updatedState.selected,
					[datasetId]: selectedFilter, // Use the provided `selectedFilter`
				}
			}
			else {
				updatedState.selectedFilter = selectedFilter // Update global selected filter
			}

			return updatedState
		}

		

		case FILTER_GROUP_DESELECT: {

			const { datasetId } = action

			let s = {
				...state,
				filterGroups: state.filterGroups.map((fg) =>
					fg.id === action.groupId
						? {
								...fg,
								isExpanded: false, // collapse
								filters: fg.filters.map((f: any) => ({
									...f,
									isSelected: false,
								})),
						  }
						: fg,
				),
			};
			if (datasetId) {
				s.selected = {
					...s.selected,
					[datasetId]: {
						...filterUtils.getSelectedFilter(s, datasetId)
					}
				}
			}
			else {
				s.selectedFilter = filterUtils.getSelectedFilter(s);
			}
			return s;
		}

		case FILTER_DESELECT_ALL: {
			const { datasetId } = action

			let updatedState = {
				...state,
				filterGroups: state.filterGroups.map((fg) => ({
					...fg,
					isExpanded: false, // Collapse all filter groups
					filters: fg.filters.map((f) => ({
						...f,
						isSelected: false, // Deselect all filters
					})),
				})),
			}

			// Step 1: Ensure `selected` is fully reset (except `filterAlwaysIn`)
			updatedState.selected = datasetId
				? {
					[datasetId]: {
						autoLabel: state.defaultFilterLabel,
						syntax: state.filterAlwaysIn ? `${state.filterAlwaysIn}==1` : "1==1",
						name: state.filterAlwaysIn || "total",
					}
				}
				
				: {}

			// Step 2: Ensure `selectedFilter` resets correctly
			updatedState.selectedFilter = {
				autoLabel: state.defaultFilterLabel,
				syntax: state.filterAlwaysIn ? `${state.filterAlwaysIn}==1` : "1==1",
				name: state.filterAlwaysIn || "total",
			}

			return updatedState
		}



		case FILTER_SET_USE_CUSTOM_LABEL: {
			let s = {
				...state,
				selectedFilter: {
					...state.selectedFilter,
					useCustomLabel: action.useCustomLabel,
				},
			};
			s.selectedFilter = filterUtils.getSelectedFilter(s);
			return s;
		}

		case FILTER_SET_CUSTOM_LABEL: {
			let s = {
				...state,
				selectedFilter: {
					...state.selectedFilter,
					customLabel: action.customLabel,
				},
			};
			s.selectedFilter = filterUtils.getSelectedFilter(s);
			return s;
		}

		case FILTER_SAMPLE_SIZES_RECEIVE: {
			const { syntax, datasetId, n } = action;
			const selectedFilter = state.selectedFilter;

			if (selectedFilter && selectedFilter.syntax === syntax) {
				return {
					...state,
					selectedFilter: {
						...selectedFilter,
						n: n, // ✅ Assign `n` to `selectedFilter`
					},
					selected: {
						...state.selected,
						...(datasetId ? { [datasetId]: { ...state.selected[datasetId], n: n } } : {}), 
					},
				};
			}
    
			return state; // If no matching syntax, return original state
		}

	}

	return state
}
